<script>
import { reactive, onMounted, watch } from 'vue'

export default {
  props: {
    total: { type: Number },
  },
  setup(props) {
    const state = reactive({ total: 0 })

    onMounted(() => { state.total = props.total || 0 })
    watch(() => props.total, (v) => { state.total = v || 0 })

    return { state }
  },
}
</script>

<template>
  <div class="card kpi-card kpi-laranja text-white h-100">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <div>
          <small class="opacity-75 text-uppercase fw-bold">Planos de Treino</small>
          <div class="kpi-valor">{{ state.total }}</div>
          <small class="opacity-90">ativos no sistema</small>
        </div>
        <div class="kpi-icon-box">
          <i class="material-icons">fitness_center</i>
        </div>
      </div>

      <div class="info-box mt-3">
        <i class="material-icons small-icon">info</i>
        <span>Soma de todos os planos cadastrados por todos os treinadores</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.kpi-card {
  border: none;
}
.kpi-laranja {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  box-shadow: 0 4px 12px rgba(234, 88, 12, 0.3);
}

.kpi-valor {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 4px 0;
}

.kpi-icon-box {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.kpi-icon-box i { font-size: 22px; }

.info-box {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
  line-height: 1.3;
}
.info-box .small-icon { font-size: 16px; }
</style>
